export default __webpack_public_path__ + "static/media/abscissa_active.efeb21df.svg";